module.exports = __webpack_public_path__ + "static/media/certificate-label.05dfeb0b.png";